import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { chaveSubtitulo } from '../nucleo/subtitulos';

/**
 * Fase 2 (W33, item 5.6): descrição curta da página, logo abaixo do título de todo cabeçalho de página (Início, seções do
 * menu, Minha conta e Notificações), no mesmo estilo do antigo e sem variante visual nova: texto pequeno em `tinta-2`. O texto
 * vem do mapa central por rota (`nucleo/subtitulos.ts`); rota sem texto não mostra nada.
 */
export function SubtituloPagina({ caminho }: { caminho?: string }) {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const chave = chaveSubtitulo(caminho ?? pathname);
  if (!chave || !i18n.exists(chave)) return null;
  return (
    <p data-subtitulo="" className="mt-1 text-sm text-tinta-2">
      {t(chave)}
    </p>
  );
}
